<template>
<div class="chapter">
<div class="inner_page">
<div class="frontMatter">
<a id="title1"></a><div class="title-frontMatter">
<div class="p"><span>Dear Reader,</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>To me, Harlequin Presents<sup>®</sup> has always been at the cutting edge of contemporary romance and I’ve loved the uninhibited scope and pleasure of writing about today’s relationships with their complex problems and passions.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>Best of all, in these stories, the dream of love we nurse in our hearts can always be fulfilled. It’s a special world we share—the magic of romance—and I hope you love it and enjoy it as much as I do, sharing the lives of others whose dearest wishes do come true.</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>Happy twenty-fifth birthday to Harlequin Presents!</span></div>
<div class="p-blanc"><span> <br/></span></div>
<div class="p"><span>Emma Darcy</span></div></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781459262102_fm02.vue?505312e0